/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Box, DataTable, Text } from 'grommet'
import { LineChart, Achievement, Group } from 'grommet-icons'
import { FaRoad } from 'react-icons/fa'
import { MdTimer } from 'react-icons/md'
import { GoCalendar } from 'react-icons/go'

class Recap extends React.Component {
  
  render() {
 
    const DATA = this.props.activities

    const columns = [
      {
        property: "semaine",
        header: <Box direction='row' gap='xsmall'><GoCalendar color='gray' size='1.5em'/><Text>Semaine</Text></Box>,
        primary: true,
        align: 'center',
      },
      {
        property: "members",
        header: <Box direction='row' gap='xsmall'><Group color='gray'/><Text>Membres</Text></Box>,
        primary: true,
        align: 'center',
      },
      {
        property: "activities",
        header: <Box direction='row' gap='xsmall'><Achievement color='gray'/><Text>Activités</Text></Box>,
        primary: true,
        align: 'center',
      },
      {
        property: "distance",
        header: <Box direction='row' gap='xsmall'><FaRoad color='gray' size='1.5em'/><Text>Distance</Text></Box>,
        primary: true,
        align: 'center',
      },
      {
        property: "time",
        header: <Box direction='row' gap='xsmall'><MdTimer color='gray' size='1.5em'/><Text>Temps</Text></Box>,
        primary: true,
        align: 'center',
      },
      {
        property: "elevation",
        header: <Box direction='row' gap='xsmall'><LineChart color='gray'/><Text>Dénivelé</Text></Box>,
        primary: true,
        align: 'center',
      },
    ];
    
    return(
      <Box align="center" pad="large">
        <DataTable columns={columns} data={DATA} />
      </Box>
    )
  }
}

export default Recap
